import React, { useState } from 'react';
import { BuildingIcon } from '@rsos/assets/icons';
import { Box, Text } from '@rsos/base-components';
import { HoveredCopyButton } from '@rsos/components/capstone/HoveredButtons';
import { handleSetIsCopiedTimer } from '@rsos/components/capstone/HoveredButtons/helpers';
import { CopyableBox, IconWrapper } from './DataCardLocation.styles';

interface EstimatedFloorLevelInterface {
  estimatedFloorLevel: number | null;
}

const EstimatedFloorLevel = ({
  estimatedFloorLevel,
}: EstimatedFloorLevelInterface) => {
  const [isCopied, setIsCopied] = useState(false);

  if (estimatedFloorLevel === null) {
    return null;
  }

  return (
    <CopyableBox isCopied={isCopied}>
      <IconWrapper mr={2}>
        <BuildingIcon width={12} />
      </IconWrapper>
      <Box>
        <Box horizontal>
          <Text size="normal" color="secondaryText">
            Estimated Floor Level:&nbsp;
          </Text>
          <Text size="normal" color="primaryText">
            {estimatedFloorLevel}
          </Text>
        </Box>
      </Box>
      <HoveredCopyButton
        copyableText={`Estimated Floor Level: ${estimatedFloorLevel}`}
        handleClick={() => handleSetIsCopiedTimer(setIsCopied)}
      />
    </CopyableBox>
  );
};

export default EstimatedFloorLevel;
